// carePlanAnimations.ts
// Animation keyframes and confetti logic for GoalsColumn

export const confettiShapes = [
    'polygon(0 0, 100% 0, 80% 100%, 20% 100%)', // rectangle
    'ellipse(50% 40% at 50% 50%)', // oval
    'polygon(50% 0, 100% 100%, 0 100%)', // triangle
    'polygon(0 20%, 100% 0, 80% 100%, 20% 100%)', // leaf
];

export const confettiColors = [
    'success.main',
    'secondary.main',
    'success.light',
    'info.main',
    'warning.main',
    'primary.main',
    'success.dark',
    'error.main',
    'info.light',
    'warning.light',
];

export const confettiKeyframes = {
    '@keyframes confettiDropLeaf': {
        '0%': {
            opacity: 0,
            transform: 'translateY(0) scale(0.8)',
        },
        '10%': {
            opacity: 1,
            transform: 'translateY(0) scale(1)',
        },
        '100%': {
            opacity: 0,
            transform: 'translateY(384px) scale(0.7)',
        },
    },
    '@keyframes partyPopperPop': {
        '0%': {
            transform: 'scale(1) rotate(0deg)',
            opacity: 1,
        },
        '20%': {
            transform: 'scale(1.3) rotate(-15deg)',
            opacity: 1,
        },
        '40%': {
            transform: 'scale(1.5) rotate(15deg)',
            opacity: 1,
        },
        '60%': {
            transform: 'scale(1.2) rotate(-8deg)',
            opacity: 1,
        },
        '80%': {
            transform: 'scale(1.1) rotate(5deg)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(1) rotate(0deg)',
            opacity: 1,
        },
    },
    '@keyframes chipCelebrate': {
        '0%': { transform: 'scale(0.8)', opacity: 0 },
        '60%': { transform: 'scale(1.15)', opacity: 1 },
        '100%': { transform: 'scale(1)', opacity: 1 },
    },
    '@keyframes shimmerMove': {
        '0%': { transform: 'translateX(-100%)' },
        '45%': { transform: 'translateX(100%)' },
        '55%': { transform: 'translateX(100%)' },
        '100%': { transform: 'translateX(-100%)' },
    },
    '@keyframes achievePulse': {
        '0%': { transform: 'scale(0.8)', opacity: 0 },
        '40%': { transform: 'scale(1.08)', opacity: 1 },
        '70%': { transform: 'scale(0.95)', opacity: 1 },
        '100%': { transform: 'scale(1)', opacity: 1 },
    },
};

// Utility to get MUI theme color
export const getThemeColor = (theme, colorKey) => theme.palette[colorKey.split('.')[0]][colorKey.split('.')[1]];
